<template><SimpleModuleDashboard :module-id="Modules.COMPRAS" :profile-id="Profiles.PERSONAL" include-php-custom :actions="actions" /></template>
<script>
import Profiles from '@/config/profiles'
import Modules from '@/config/modules'
import SimpleModuleDashboard from '@/components/inc/dashboard/SimpleModuleDashboard'
export default { components: { SimpleModuleDashboard }, data: () => ({ Modules, Profiles, actions: [
  { id: 'purchase', reference: 'purchase', route: 'PurchaseStaffPurchase', tone: 'primary' },
  { id: 'purchaseCategory', reference: 'purchaseCategory', route: 'PurchaseStaffPurchaseCategory', tone: 'primary', group: 'Configuraciones' },
  { id: 'infoPayment', reference: 'infoPayment', route: 'PurchaseStaffPurchaseInfoPayment', tone: 'primary', group: 'Configuraciones' },
  { id: 'currentsAccounts', reference: 'currentsAccounts', route: 'PurchaseStaffCurrentsAccounts', tone: 'primary' },
  { id: 'reports', reference: 'reports', route: 'PurchaseStaffReports', tone: 'primary' },
] }) }
</script>
